import { CoverageList } from "./components/CoverageList";
import { OCRStatusList } from "./components/OCRStatusList";
import { QueryInfoCard } from "./components/QueryInfoCard";
import { QuerySectionModals } from "./components/QuerySectionModals";
import type { QuerySectionProps } from "./types";
import { useCoverageData } from "./hooks/useCoverageData";

export const QuerySection = ({
  fileId,
  organization,
  isCoverageComplete,
  isNoCoverage,
  onCoverageChange,
}: QuerySectionProps) => {
  const { allCoverages, isLoading, hasCoverage, hasCoverageValidationErrors } =
    useCoverageData(fileId, isCoverageComplete, isNoCoverage);

  return (
    <>
      <OCRStatusList fileId={fileId} />

      {onCoverageChange && (
        <QueryInfoCard
          isCoverageComplete={isCoverageComplete || false}
          isNoCoverage={isNoCoverage || false}
          onCoverageChange={onCoverageChange}
          hasCoverage={hasCoverage}
          hasCoverageValidationErrors={hasCoverageValidationErrors}
        />
      )}

      <CoverageList
        allCoverages={allCoverages}
        isLoading={isLoading}
        hasCoverage={hasCoverage}
        isCoverageComplete={isCoverageComplete}
        isNoCoverage={isNoCoverage}
      />

      <QuerySectionModals fileId={fileId} organization={organization} />
    </>
  );
};
